import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../actions';

import ScrollToTopOnRouteChange from './ScrollToTopOnRouteChange';

import Header from './header/Main';

import Home from './home/Main';

import Login from './login/Main';
import Logout from './Logout';

import JoXyzDemo from './jo-xyz-demo';
import Dashboard from './Dashboard';
import NoPermissions from './NoPermissions';

import Settings from './Settings';
import Contact from './Contact';
import ContactConfirmation from './ContactConfirmation';
import CheckYourEmail from './CheckYourEmail';

import AiNotesAdmin from './admin/ai-notes/Main';
import PostForm from './admin/ai-notes/PostForm';
import AiNotes from './ai-notes/Main';

import AdminConsoleMain from './admin/console/Main';
import UserManagementPage from './admin/console/UserManagementPage';
import ModelManagement from './admin/console/ModelManagement';

import Unsubscribe from './newsletter/Unsubscribe';
import Subscribed from './newsletter/Subscribed';
import AlreadySubscribed from './newsletter/AlreadySubscribed';

import ToolsMain from './tools/Main';
import ArticleToMediaMain from './tools/article-to-media/Main';
import ResultsPage from './tools/article-to-media/components/ResultsPage';
import AdminToolsMain from './admin/tools/article-to-media/Main';
import AccessCodeManagement from './admin/tools/article-to-media/AccessCodeManagement';
import ToolSettings from './admin/tools/article-to-media/ToolSettings';
import PromptsManagement from './admin/tools/article-to-media/PromptsManagement';
import ArticleManagement from './admin/tools/article-to-media/ArticleManagement';
import DomainBlocklist from './admin/tools/article-to-media/DomainBlocklist';
import DomainAllowlist from './admin/tools/article-to-media/DomainAllowlist';
import ToolAnalytics from './admin/tools/article-to-media/ToolAnalytics';
import UrlProcessingLog from './admin/tools/article-to-media/UrlProcessingLog';
import DeleteReview from './admin/tools/article-to-media/DeleteReview';
import SpendReport from './admin/tools/article-to-media/SpendReport';
import TermsOfService from './legal/TermsOfService';
import PrivacyPolicy from './legal/PrivacyPolicy';
import NotFound from './common/NotFound';

import Footer from './Footer';

// Helper component to conditionally render header and footer
const ConditionalLayout = ({ children }) => {
    const location = useLocation();
    const isDemoRoute = location.pathname.startsWith('/jo-xyz-demo');
    const isAdminRoute = location.pathname.startsWith('/admin/ai-notes');
    
    if (isDemoRoute) {
        // For demo routes, render only the demo content without header/footer
        return <>{children}</>;
    }
    
    // For all other routes, render with header and footer (except admin routes)
    return (
        <>
            <Header />
            <div className="container-fluid px-0" style={{ 
                background: 'linear-gradient(135deg, rgba(232, 232, 232, 0.92) 0%, rgba(248,250,252,0.95) 100%)',
                color:"rgba(0,0,0,0.8)", 
                position:"relative", 
                width:"100%", 
                margin: "0", 
                padding: "0",
                minHeight: '100vh'
            }}>
                <div className="min-vh-100 px-0">
                    {children}
                </div>
                {!isAdminRoute && (
                    <div className="container-fluid px-0" style={{ overflowX: 'hidden' }} >
                        <Footer />  
                    </div>
                )}
            </div>
        </>
    );
};

class App extends Component {

    componentDidMount() {
        this.props.fetchUser();        
    }

    componentDidUpdate() {
        
    }

    renderAnalytics() {
        
              
    }

    render() {        
        
        
        return (
            <>
                
                <BrowserRouter>                                        
                    <ScrollToTopOnRouteChange />
                    <ConditionalLayout>
                        <Switch>
                            {/* Public Routes */}
                            <Route exact path="/" component={Home} />
                            <Route exact path="/login" component={Login} />
                            <Route exact path="/check-your-email" component={CheckYourEmail} />
                            <Route exact path="/contact" component={Contact} />
                            <Route exact path="/contact/confirmation" component={ContactConfirmation} />
                            
                            {/* AI Notes Routes */}
                            <Route exact path="/ai-notes" component={AiNotes} />
                            
                            {/* Newsletter Routes */}
                            <Route exact path="/newsletter/subscribed" component={Subscribed} />
                            <Route exact path="/newsletter/already-subscribed" component={AlreadySubscribed} />
                            <Route exact path="/newsletter/unsubscribe" component={Unsubscribe} />
                            <Route exact path="/newsletter/unsubscribe/:token" component={Unsubscribe} />
                            
                            {/* Protected Routes */}
                            <Route exact path="/logout" component={Logout} />
                            <Route exact path="/dashboard" component={Dashboard} />
                            <Route exact path="/admin-console" component={Settings} />
                            <Route exact path="/jo-xyz-demo" component={JoXyzDemo} />
                            <Route exact path="/jo-xyz-demo/*" component={JoXyzDemo} />
                            <Route exact path="/no-permissions" component={NoPermissions} />

                            {/* Admin Console Routes */}
                            <Route exact path="/admin/console" component={AdminConsoleMain} />
                            <Route exact path="/admin/console/users" component={UserManagementPage} />
                            <Route exact path="/admin/console/models" component={ModelManagement} />

                            {/* AI Notes Admin Routes */}
                            <Route exact path="/admin/ai-notes" component={AiNotesAdmin} />
                            <Route exact path="/admin/ai-notes/new" component={PostForm} />
                            <Route exact path="/admin/ai-notes/edit/:id" component={PostForm} />

                            {/* AI Notes Post Detail Route - must come after admin routes */}
                            <Route exact path="/ai-notes/:slug" component={AiNotes} />

                            {/* Tools Routes */}
                            <Route exact path="/tools" component={ToolsMain} />
                            <Route exact path="/tools/article-to-media" component={ArticleToMediaMain} />
                            <Route exact path="/tools/article-to-media/:slug" component={ResultsPage} />

                            {/* Admin Tools Routes */}
                            <Route exact path="/admin/tools" component={AdminToolsMain} />
                            <Route exact path="/admin/tools/access-codes" component={AccessCodeManagement} />
                            <Route exact path="/admin/tools/settings" component={ToolSettings} />
                            <Route exact path="/admin/tools/prompts" component={PromptsManagement} />
                            <Route exact path="/admin/tools/articles" component={ArticleManagement} />
                            <Route exact path="/admin/tools/allowlist" component={DomainAllowlist} />
                            <Route exact path="/admin/tools/blocklist" component={DomainBlocklist} />
                            <Route exact path="/admin/tools/analytics" component={ToolAnalytics} />
                            <Route exact path="/admin/tools/url-log" component={UrlProcessingLog} />
                            <Route exact path="/admin/tools/delete-review" component={DeleteReview} />
                            <Route exact path="/admin/tools/spend-report" component={SpendReport} />

                            {/* Legal Routes */}
                            <Route exact path="/terms-of-service" component={TermsOfService} />
                            <Route exact path="/privacy-policy" component={PrivacyPolicy} />

                            {/* 404 Fallback - must be last */}
                            <Route component={NotFound} />
                        </Switch>
                    </ConditionalLayout>                               
                </BrowserRouter>
            </>
        );
    }
};



function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps, actions)(App);
